// Module
var code = "<div class=\"p-2 text-center\">\n  <i class=\"fa fa-spinner fa-pulse f-color-primary\"></i>\n</div>\n";
// Exports
module.exports = code;